import Vue from 'vue';

const failed = (error, context) => {
  toastr.error("Something went wrong");
}

const success = (response, context) => {
  toastr.success("success");
};

export default (context, data, id) => {

  return Vue.$http.post('/update-airbnb-booking', data).then((response) => {
    if (response && response.status === 200) {
      success(response, context);
    }else{
      failed(error, context);
    }
  }).catch((error) => {
    failed(error, context);
  }).finally(_ => $("#update-airbnb-booking-" + id).modal('hide'))

};


// WEBPACK FOOTER //
// ./src/app/services/booking/updateAirbnbBooking.js